import { toTypedRxJsonSchema } from 'rxdb';
import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema } from 'rxdb';

export const staffSchemaLiteral = {
  title: 'staff',
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 100 },
    name: { type: 'string', maxLength: 255 },
    default_branch_id: { type: 'string', maxLength: 100 },
    is_active: { type: 'boolean' },
    phone: { type: ['string', 'null'], maxLength: 50 },
    email: { type: ['string', 'null'], maxLength: 255 },
    role: { type: ['string', 'null'], maxLength: 100 },
    daily_salary: { type: 'number' },
    pay_frequency: { type: 'string', maxLength: 20 },
    monthly_salary: { type: ['number', 'null'] },
    work_days: { type: 'object' },
    created_at: { type: 'string', maxLength: 50 },
    updated_at: { type: 'string', maxLength: 50 },
    is_deleted: { type: 'boolean' },
    
    last_modified_by: { type: ['string', 'null'], maxLength: 100 },
  },
  required: ['id', 'name', 'default_branch_id', 'is_active', 'updated_at', 'is_deleted'],
  indexes: ['is_deleted', 'updated_at', 'default_branch_id'],
} as const;

const schemaTyped = toTypedRxJsonSchema(staffSchemaLiteral);
export type StaffDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;
export const staffSchema: RxJsonSchema<StaffDocType> = staffSchemaLiteral;
